export default function () {
  return [
    // --- 1. SPRZEDAŻ ---
    {
      title: {
        pl: 'Sprzedaż',
        en: 'Sales'
      },
      htmlBefore: '<i class="material-icons">store</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Zamówienia',
            en: 'Orders'
          },
          to: '/zamowienia',
          permission: 'orders',
          items: [
            {
              title: {
                pl: 'Zamówienia HPL',
                en: 'Orders HPL'
              },
              to: '/zamowienia',
              permission: 'orders',
              counter: 'orders'
            },
            {
              title: {
                pl: 'Zamówienia partnerów',
                en: 'Partner orders'
              },
              to: '/zamowienia-partnerow',
              permission: 'orders',
              userType: 'not-warehouseman',
              counter: 'customer_orders'
            },
            {
              title: {
                pl: 'Zamówienia indent',
                en: 'Indent orders'
              },
              to: '/zamowienia-indent',
              htmlBefore: '',
              htmlAfter: '',
              permission: 'orders',
              userType: 'not-customer-and-warehouseman',
              counter: 'indent'
            },
          ]
        },
        {
          title: {
            pl: 'Oferta',
            en: 'Offer'
          },
          to: '/oferty',
          permission: 'orders',
          items: [
            {
              title: {
                pl: 'Oferty HPL',
                en: 'Offers HPL'
              },
              to: '/oferty',
              permission: 'orders',
              userType: 'not-customer-and-warehouseman',
              counter: 'offers'
            },
            {
              title: {
                pl: 'Oferty Indent',
                en: 'Indent Offers'
              },
              to: '/oferty-indent',
              permission: 'orders',
              userType: 'not-customer-and-warehouseman',
              counter: 'indent_offers'
            }
          ]
        },
        {
          title: {
            pl: 'Rejestry',
            en: 'Registry'
          },
          to: '/rejestr-indent',
          htmlBefore: '',
          htmlAfter: '',
          permission: 'orders',
          items: [
            {
              title: {
                pl: 'Rejestr indent',
                en: 'Indent registry'
              },
              to: '/rejestr-indent',
              permission: 'orders',
              userType: 'not-customer-and-warehouseman',
              counter: 'indent',
            }
          ]
        }
      ]
    },

    // --- 2. CRM ---
    {
      title: {
        pl: 'CRM',
        en: 'CRM'
      },
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Klienci',
            en: 'Customers'
          },
          to: '/klienci',
          permission: 'customers'
        },
        {
          title: {
            pl: 'Kontakty z klientami',
            en: 'Contacts with customers'
          },
          to: '/kontakty-z-klientami',
          permission: 'contacts'
        },
        {
          title: {
            pl: 'Potencjalni klienci',
            en: 'Potential customers'
          },
          to: '/potencjalni-klienci',
          permission: 'potential_customers'
        },
        {
          title: {
            pl: 'Klienci z targów',
            en: 'Market customers'
          },
          to: '/klienci-z-targow',
          permission: 'market_customers'
        },
        {
          title: {
            pl: 'Agenci',
            en: 'Agents'
          },
          to: '/agenci',
          permission: 'agents'
        },
        {
          title: {
            pl: 'Reklamacje',
            en: 'Complaints'
          },
          to: '/reklamacje',
          permission: 'complaints',
          userType: 'not-customer-and-warehouseman'
        }
      ]
    },

    // --- 3. PRODUKCJA I USŁUGI ---
    {
      title: {
        pl: 'Produkcja i Usługi',
        en: 'Production & Services'
      },
      htmlBefore: '<i class="material-icons">precision_manufacturing</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Planowanie zdobień',
            en: 'Services planning'
          },
          to: '/planowanie-zdobien',
          permission: 'services_schedule'
        },
        {
          title: {
            pl: 'Zamówienia w Hafciarni',
            en: 'Orders in Hafciarnia'
          },
          to: '/zamowienia-hafciarnia',
          permission: 'orders',
          userType: 'not-customer-and-warehouseman',
        },
        {
          title: {
            pl: 'Wykonawcy',
            en: 'Contractors'
          },
          to: '/wykonawcy',
          permission: 'contractors'
        }
      ]
    },

    // --- 4. MAGAZYN I LOGISTYKA ---
    {
      title: {
        pl: 'Magazyn i Logistyka',
        en: 'Warehouse & Logistics'
      },
      htmlBefore: '<i class="material-icons">local_shipping</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Do sprawdzenia na magazynie',
            en: 'To check in warehouse'
          },
          to: '/do-sprawdzenia',
          permission: 'orders',
          userType: 'warehouseman'
        },
        {
          title: {
            pl: 'Oczekujące na dostawę',
            en: 'Waiting for delivery'
          },
          to: '/oczekujace-na-dostawe',
          permission: 'orders',
          userType: 'warehouseman'
        },
        {
          title: {
            pl: 'Wszystkie zamówienia',
            en: 'All orders'
          },
          to: '/zamowienia-wszystkie',
          permission: 'orders',
          userType: 'warehouseman'
        },
        {
          title: {
            pl: 'Przesyłki',
            en: 'Shipments'
          },
          to: '/przesylki',
          permission: 'shipments',
          items: [
            {
              title: {
                pl: 'Przesyłki',
                en: 'Shipments'
              },
              to: '/przesylki'
            },
            {
              title: {
                pl: 'Raporty',
                en: 'Reports'
              },
              to: '/przesylki-raporty'
            }
          ]
        },
        {
          title: {
            pl: 'Kontenery',
            en: 'Containers'
          },
          to: '/kontenery',
          permission: 'containers',
          items: [
            {
              title: {
                pl: 'Kontenery',
                en: 'Containers'
              },
              to: '/kontenery',
              permission: 'containers'
            },
            {
              title: {
                pl: 'Rezerwacje',
                en: 'Resevations'
              },
              to: '/kontenery/rezerwacje',
              permission: 'containers'
            }
          ]
        }
      ]
    },

    // --- 5. ZAKUPY ---
    {
      title: {
        pl: 'Zakupy',
        en: 'Purchasing'
      },
      htmlBefore: '<i class="material-icons">shopping_basket</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Zamówienia u dostawców',
            en: 'Purchases'
          },
          to: '/zakupy',
          permission: 'purchases'
        },
        {
          title: {
            pl: 'Rezerwacje u dostawców',
            en: 'Purchase reservations'
          },
          to: '/zakupy/rezerwacje',
          permission: 'purchases'
        }
      ]
    },

    // --- 6. PRODUKTY I CENNIKI ---
    {
      title: {
        pl: 'Produkty i Cenniki',
        en: 'Products & Prices'
      },
      htmlBefore: '<i class="material-icons">menu_book</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Produkty',
            en: 'Products'
          },
          to: '/produkty',
          permission: 'products',
          items: [
            {
              title: {
                pl: 'Produkty HPL',
                en: 'HPL products'
              },
              to: '/produkty'
            },
            {
              title: {
                pl: 'Produkty Indent',
                en: 'Indent products'
              },
              to: '/produkty-indent'
            },
            {
              title: {
                pl: 'Do zatwierdzenia ze szwalni',
                en: 'For approval from sewing room'
              },
              to: '/produkty-do-zatwierdzenia-ze-szwalni'
            },
            {
              title: {
                pl: 'Tagi produktów',
                en: 'Product tags'
              },
              to: '/produkty/tagi'
            },
            {
              title: {
                pl: 'Kategorie',
                en: 'Categories'
              },
              to: '/kategorie-produktow'
            }
          ]
        },
        {
          title: {
            pl: 'Zdobienia',
            en: 'Services'
          },
          to: '/zdobienia',
          permission: 'services',
          items: [
            {
              title: {
                pl: 'Zdobienia HPL',
                en: 'HPL services'
              },
              to: '/zdobienia'
            },
            {
              title: {
                pl: 'Zdobienia Indent',
                en: 'Indent services'
              },
              to: '/zdobienia-indent'
            },
            {
              title: {
                pl: 'Grupy zdobień',
                en: 'Services groups'
              },
              to: '/zdobienia/grupy'
            }
          ]
        },
        {
          title: {
            pl: 'Cenniki',
            en: 'Prices'
          },
          htmlBefore: '',
          htmlAfter: '',
          permission: 'prices',
          items: [
            {
              title: {
                pl: 'Cenniki produktów',
                en: 'Products prices'
              },
              to: '/cenniki/produkty'
            },
            {
              title: {
                pl: 'Cenniki zdobień',
                en: 'Services prices'
              },
              to: '/cenniki/zdobienia'
            },
            {
              title: {
                pl: 'Cenniki setup',
                en: 'Setup prices'
              },
              to: '/cenniki/setup'
            }
          ]
        }
      ]
    },

    // --- 7. FINANSE I ZARZĄDZANIE ---
    {
      title: {
        pl: 'Finanse i Zarządzanie',
        en: 'Finance & Management'
      },
      htmlBefore: '<i class="material-icons">attach_money</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Finanse',
            en: 'Finance'
          },
          to: '/rozliczenia',
          permission: 'settlements',
          items: [
            {
              title: {
                pl: 'Rozliczenia',
                en: 'Settlements'
              },
              to: '/rozliczenia',
              permission: 'settlements',
            }
          ]
        },
        {
          title: {
            pl: 'KPI',
            en: 'KPI'
          },
          to: '/cele-pracownikow',
          permission: 'kpi_targets',
          items: [
            {
              title: {
                pl: 'Cele pracowników',
                en: 'Workers targets'
              },
              to: '/cele-pracownikow',
              permission: 'kpi_targets',
            },
            {
              title: {
                pl: 'Realizacja KPI',
                en: 'KPI realisation'
              },
              to: '/realizacja-kpi',
              permission: 'kpi_targets'
            },
            {
              title: {
                pl: 'Statystyki',
                en: 'Stats'
              },
              to: '/statystyki',
              htmlBefore: '<i class="material-icons">poll</i>',
              htmlAfter: '',
              permission: 'stats'
            }
          ]
        },
        {
          title: {
            pl: 'Raporty',
            en: 'Reports'
          },
          to: '/raporty',
          permission: 'reports',
          items: [
            {
              title: {
                pl: 'Raport zadłużeń',
                en: 'Debt report'
              },
              to: '/raport-zadluzen',
              permission: 'settlements'
            },
            {
              title: {
                pl: 'Raporty dodatkowe',
                en: 'Additional reports'
              },
              to: '/raporty',
              permission: 'reports'
            }
          ]
        }
      ]
    },

    // --- 8. FUNKCJE SPRZEDAŻOWE ---
    {
      title: {
        pl: 'Funkcje Sprzedażowe',
        en: 'Sales Tools'
      },
      htmlBefore: '<i class="material-icons">ads_click</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Segmenty',
            en: 'Segments'
          },
          to: '/funkcje-sprzedazowe/segmenty',
          permission: 'marketing'
        },
        {
          title: {
            pl: 'Wiadomości e-mail',
            en: 'E-mail messages'
          },
          to: '/funkcje-sprzedazowe/wiadomosci-email',
          permission: 'marketing'
        }
      ]
    },

    // --- 9. SYSTEM ---
    {
      title: {
        pl: 'System',
        en: 'System'
      },
      htmlBefore: '<i class="material-icons">settings_applications</i>',
      htmlAfter: '',
      items: [
        {
          title: {
            pl: 'Użytkownicy',
            en: 'Users'
          },
          to: '/uzytkownicy',
          permission: 'users'
        },
        {
          title: {
            pl: 'Ustawienia',
            en: 'Settings'
          },
          to: '/ustawienia',
          permission: 'settings',
          items: [
            {
              title: {
                pl: 'Kraje',
                en: 'Countries'
              },
              to: '/ustawienia/kraje',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Języki',
                en: 'Languages'
              },
              to: '/ustawienia/jezyki',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Waluty',
                en: 'Currencies'
              },
              to: '/ustawienia/waluty',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Słowniki wielojęzyczności',
                en: 'Translation dictionaries'
              },
              to: '/ustawienia/slowniki-wielojezycznosci',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Grupy użytkowników',
                en: 'User groups'
              },
              to: '/ustawienia/grupy-uzytkownikow',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Tagi klientów',
                en: 'Customers tags'
              },
              to: '/ustawienia/tagi-klientow',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Tagi zamówień',
                en: 'Orders tags'
              },
              to: '/ustawienia/tagi-zamowien',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Tagi promocyjne',
                en: 'Promotional tags'
              },
              to: '/ustawienia/tagi-promocyjne',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Spedytorzy',
                en: 'Shippers'
              },
              to: '/ustawienia/spedytorzy',
              permission: 'shippers'
            },
            {
              title: {
                pl: 'Typy kontaktów z klientem',
                en: 'Types of contacts with customer'
              },
              to: '/ustawienia/typy-kontaktow-z-klientem',
              permission: 'settings'
            },
            /*
            ,{
              title: {
                pl: 'Źródła pozyskania',
                en: 'Source of acquisition'
              },
              to: '/ustawienia/zrodla-pozyskania',
              permission: 'settings'
            },
            */
            {
              title: {
                pl: 'Czas realizacji',
                en: 'Processing times'
              },
              to: '/ustawienia/czas-realizacji',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Integracje',
                en: 'Integrations'
              },
              to: '/ustawienia/integracje',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Dodatkowe potwierdzenia',
                en: 'Additional confirmations'
              },
              to: '/ustawienia/potwierdzenia',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Szablony e-mail',
                en: 'E-mail templates'
              },
              to: '/ustawienia/szablony-email',
              permission: 'settings'
            },
            {
              title: {
                pl: 'Komunikaty systemowe',
                en: 'System messages'
              },
              to: '/ustawienia/komunikaty-systemowe',
              permission: 'settings'
            }
          ]
        }
      ]
    }
  ];
}
